export default "__VITE_ASSET__CzTZz1mO__"